var AddToHomeScreenButton       = require("./AddToHomeScreenButton"),
    BookmarksButton             = require("./BookmarksButton"),
    BrandDropdown               = require("./BrandDropdown"),
    CategoryDropdown            = require("./CategoryDropdown"),
    Dropdown                    = require("app/ui/Dropdown"),
    DropdownCaptureSupport      = require("app/ui/DropdownCaptureSupport"),
    HyperLinkSupport            = require("enyo-ui/HyperLinkSupport"),
    IconButton                  = require("app/ui/IconButton"),
    LoginButton                 = require("./LoginButton"),
    LogoutButton                = require("./LogoutButton"),
    ModalDropdownSupport        = require("app/AppLayout/ModalDropdownSupport"),
    PopupLayout                 = require("app/AppLayout/PopupLayout"),
    PreviewModeButton           = require("./PreviewModeButton"),
    ProfileButton               = require("./ProfileButton"),
    Scroller                    = require("enyo-ui/Scroller"),
    ScrollerDecoratorScrollbars = require("app/ui/ScrollerDecoratorScrollbars"),
    SignUpButton                = require("./SignUpButton"),
    buttons                     = require("app/theme/buttons"),
    closeButtonThemeVars        = require("app/theme/IconButtonVariables--close"),
    config                      = require("app/config"),
    frameThrottle               = require("enyo-perf/utils").frameThrottle,
    get                         = require("object-path").get,
    icons                       = require("app/theme/icons"),
    kind                        = require("enyo/kind"),
    onHyperlinkTap              = require("app/utils/onHyperlinkTap"),
    quickMacroize               = require("enyo/macroize").quickMacroize,
    themeVars                   = require("app/theme/variables.js");

require("./MenuDropdown.less");
require("app/theme/IconButton--header-dropdown-negative.less");
require("app/theme/IconButton--header-dropdown-positive.less");
require("app/theme/IconButton--header-dropdown.less");
require("app/theme/IconButton--header.less");
require("app/theme/styles/popups/Popup--plain.less");
require("app/theme/ScrollerDecoratorScrollbars--header.less");

module.exports = kind(/** @lends  app.AppHeader.MenuDropdown.prototype */ {

    /**
     * @private
     */
    name: "app.AppHeader.MenuDropdown",

    /**
     * @private
     */
    kind: Dropdown,

    /**
     * @private
     */
    mixins: [
        DropdownCaptureSupport,
        ModalDropdownSupport
    ],

    /**
     * @private
     */
    classes: "app-app-header-menu-dropdown",

    /**
     * The kind that will remain visible at all times and toggles the
     * dropdown when tapped.
     *
     * @type  {enyo.Control}
     * @public
     */
    activatorKind: IconButton,

    /**
     * Options for the activator.
     *
     * @type  {Object=}
     * @public
     */
    activatorOptions: {
        theme: buttons["app.AppHeader.MenuDropdown.Activator"],
        icon:  icons["app.AppHeader.MenuDropdown.Activator"]
    },

    /**
     * Options for the dropdown control
     *
     * @type  {Object=}
     * @public
     */
    dropdownOptions: {
        theme:           "plain",
        showCloseButton: false
    },

    /**
     * @private
     */
    components: [{
        name:               "scrollerDecorator",
        kind:               ScrollerDecoratorScrollbars,
        classes:            "app-app-header-menu-dropdown__scroller-decorator",
        scrollerPath:       ".owner.$.scroller",
        theme:              "header",
        fadeChromeOnScroll: true,
        components:         [{
            name:           "scroller",
            kind:           Scroller,
            classes:        "app-app-header-menu-dropdown__scroller",
            vertical:       true,
            horizontal:     false,
            scrollChaining: false,
            components:     [{
                classes:    "app-app-header-menu-dropdown__menu",
                components: [{
                    name:               "previewModeButton",
                    kind:               PreviewModeButton,
                    classes:            "app-app-header-menu-dropdown__preview-mode-button",
                    showing:            false,
                    theme:              buttons["app.AppHeader.MenuDropdown.previewModeButton"],
                    loadingIcon:        icons["app.AppHeader.MenuDropdown.PreviewModeButton.loading"],
                    previewModeOnIcon:  icons["app.AppHeader.MenuDropdown.PreviewModeButton.previewModeOn"],
                    previewModeOffIcon: icons["app.AppHeader.MenuDropdown.PreviewModeButton.previewModeOff"]
                }, {
                    name:          "searchButton",
                    kind:          IconButton,
                    mixins:        [HyperLinkSupport],
                    classes:       "app-app-header-menu-dropdown__search-button",
                    theme:         buttons["app.AppHeader.MenuDropdown.searchButton"],
                    icon:          icons["app.AppHeader.MenuDropdown.searchButton"],
                    iconAlignment: "left",
                    ontap:         "onHyperlinkTap"
                }, {
                    name:          "homeButton",
                    kind:          IconButton,
                    classes:       "app-app-header-menu-dropdown__home-button",
                    mixins:        [HyperLinkSupport],
                    theme:         buttons["app.AppHeader.MenuDropdown.homeButton"],
                    icon:          icons["app.AppHeader.MenuDropdown.homeButton"],
                    iconAlignment: "left",
                    ontap:         "onHyperlinkTap"
                }, {
                    name:    "signUpButton",
                    kind:    SignUpButton,
                    classes: "app-app-header-menu-dropdown__sign-up-button",
                    showing: false,
                    theme:   buttons["app.AppHeader.MenuDropdown.signUpButton"],
                    icon:    icons["app.AppHeader.MenuDropdown.signUpButton"],
                    ontap:   "onButtonTap"
                }, {
                    name:          "loginButton",
                    kind:          LoginButton,
                    classes:       "app-app-header-menu-dropdown__login-button",
                    showing:       false,
                    theme:         buttons["app.AppHeader.MenuDropdown.loginButton"],
                    loadingIcon:   icons["app.AppHeader.MenuDropdown.LoginButton.loading"],
                    loggedInIcon:  icons["app.AppHeader.MenuDropdown.LoginButton.loggedIn"],
                    loggedOutIcon: icons["app.AppHeader.MenuDropdown.LoginButton.loggedOut"],
                    ontap:         "onButtonTap"
                }, {
                    name:    "addToHomeScreenButton",
                    kind:    AddToHomeScreenButton,
                    classes: "app-app-header-menu-dropdown__add-to-home-screen-button",
                    theme:   buttons["app.AppHeader.MenuDropdown.addToHomeScreenButton"],
                    icon:    icons["app.AppHeader.MenuDropdown.addToHomeScreenButton"]
                }, {
                    name:          "playlistsButton",
                    kind:          IconButton,
                    mixins:        [HyperLinkSupport],
                    classes:       "app-app-header-menu-dropdown__playlists-button",
                    showing:       false,
                    theme:         buttons["app.AppHeader.MenuDropdown.playlistsButton"],
                    icon:          icons["app.AppHeader.MenuDropdown.playlistsButton"],
                    iconAlignment: "left",
                    ontap:         "onHyperlinkTap"
                }, {
                    name:        "bookmarksButton",
                    kind:        BookmarksButton,
                    classes:     "app-app-header-menu-dropdown__bookmarks-button",
                    showing:     false,
                    theme:       buttons["app.AppHeader.MenuDropdown.bookmarksButton"],
                    loadingIcon: icons["app.AppHeader.MenuDropdown.BookmarksButton.loading"],
                    loadedIcon:  icons["app.AppHeader.MenuDropdown.BookmarksButton.loaded"],
                    ontap:       "onButtonTap"
                }, {
                    name:          "genresButton",
                    kind:          IconButton,
                    mixins:        [HyperLinkSupport],
                    classes:       "app-app-header-menu-dropdown__genres-button",
                    showing:       false,
                    theme:         buttons["app.AppHeader.MenuDropdown.genresButton"],
                    icon:          icons["app.AppHeader.MenuDropdown.genresButton"],
                    iconAlignment: "left",
                    ontap:         "onHyperlinkTap"
                }, {
                    name:          "artistsButton",
                    kind:          IconButton,
                    mixins:        [HyperLinkSupport],
                    classes:       "app-app-header-menu-dropdown__artists-button",
                    showing:       false,
                    theme:         buttons["app.AppHeader.MenuDropdown.artistsButton"],
                    icon:          icons["app.AppHeader.MenuDropdown.artistsButton"],
                    iconAlignment: "left",
                    ontap:         "onHyperlinkTap"
                }, {
                    name:                 "categoryDropdown",
                    kind:                 CategoryDropdown,
                    classes:              "app-app-header-menu-dropdown__category-button",
                    showing:              false,
                    propagateCapturedTap: false,
                    tapContainerPath:     ".$.dropdown",
                    activatorOptions:     {
                        theme:         buttons["app.AppHeader.MenuDropdown.CategoryDropdown.activator"],
                        loadingIcon:   icons["app.AppHeader.MenuDropdown.CategoryDropdown.Activator.loading"],
                        loadedIcon:    icons["app.AppHeader.MenuDropdown.CategoryDropdown.Activator.loaded"],
                        iconAlignment: "left"
                    },
                    dropdownOptions: {
                        classes:       "app-app-header-menu-dropdown__category-popup",
                        layoutKind:    PopupLayout,
                        layoutOptions: {
                            alignment:       "fullLayout",
                            expand:          false,
                            overlapSafeArea: false,

                            /**
                             * @returns {number} The margin in pixels
                             */
                            marginTop: function() {
                                return themeVars.getContentPaddingVerticalPx()
                                    + (this.container.get("showCloseButton")
                                        ? closeButtonThemeVars.getIconSize() / 2
                                        : 0);
                            },

                            /**
                             * @returns {number} The margin in pixels
                             */
                            marginBottom: function() {
                                return themeVars.getContentPaddingVerticalPx();
                            },
                            scrollerPath:          ".container.$.categoryMenu.$.scroller",
                            scrollerDecoratorPath: ".container.$.categoryMenu"
                        },
                        theme:           "plain",
                        showCloseButton: true,
                        floating:        true,
                        useScrim:        true,
                        scrimOptions:    {
                            classes: "app-app-header-menu-dropdown__category-popup-scrim app-ui-scrim"
                        }
                    }
                }, {
                    name:                 "brandDropdown",
                    kind:                 BrandDropdown,
                    classes:              "app-app-header-menu-dropdown__brand-button",
                    showing:              false,
                    propagateCapturedTap: false,
                    tapContainerPath:     ".$.dropdown",
                    activatorOptions:     {
                        theme:         buttons["app.AppHeader.MenuDropdown.BrandDropdown.activator"],
                        loadingIcon:   icons["app.AppHeader.MenuDropdown.BrandDropdown.Activator.loading"],
                        loadedIcon:    icons["app.AppHeader.MenuDropdown.BrandDropdown.Activator.loaded"],
                        iconAlignment: "left"
                    },
                    dropdownOptions: {
                        classes:       "app-app-header-menu-dropdown__brand-popup",
                        layoutKind:    PopupLayout,
                        layoutOptions: {
                            alignment:       "fullLayout",
                            expand:          false,
                            overlapSafeArea: false,

                            /**
                             * @returns {number} The margin in pixels
                             */
                            marginTop: function() {
                                return themeVars.getContentPaddingVerticalPx()
                                    + (this.container.get("showCloseButton")
                                        ? closeButtonThemeVars.getIconSize() / 2
                                        : 0);
                            },

                            /**
                             * @returns {number} The margin in pixels
                             */
                            marginBottom: function() {
                                return themeVars.getContentPaddingVerticalPx();
                            },
                            scrollerPath:          ".container.$.brandMenu.$.scroller",
                            scrollerDecoratorPath: ".container.$.brandMenu"
                        },
                        theme:           "plain",
                        showCloseButton: true,
                        floating:        true,
                        useScrim:        true,
                        scrimOptions:    {
                            classes: "app-app-header-menu-dropdown__brand-popup-scrim app-ui-scrim"
                        }
                    }
                }, {
                    name:    "profileButton",
                    kind:    ProfileButton,
                    classes: "app-app-header-menu-dropdown__profile-button",
                    showing: false,
                    theme:   buttons["app.AppHeader.MenuDropdown.privacyButton"],
                    ontap:   "onButtonTap"
                }, {
                    name:          "privacyButton",
                    kind:          IconButton,
                    mixins:        [HyperLinkSupport],
                    classes:       "app-app-header-menu-dropdown__privacy-button",
                    showing:       false,
                    theme:         buttons["app.AppHeader.MenuDropdown.privacyButton"],
                    icon:          icons["app.AppHeader.MenuDropdown.privacyButton"],
                    iconAlignment: "left",
                    ontap:         "onHyperlinkTap"
                }, {
                    name:       "cookiePreferencesButton",
                    kind:       IconButton,
                    tag:        "a",
                    attributes: {
                        href: "#"
                    },
                    classes:       "app-app-header-menu-dropdown__cookie-preferences-button cky-banner-element",
                    theme:         buttons["app.AppHeader.MenuDropdown.cookiePreferencesButton"],
                    icon:          icons["app.AppHeader.MenuDropdown.cookiePreferencesButton"],
                    iconAlignment: "left"
                }, {
                    name:          "faqButton",
                    kind:          IconButton,
                    mixins:        [HyperLinkSupport],
                    classes:       "app-app-header-menu-dropdown__faq-button",
                    showing:       false,
                    theme:         buttons["app.AppHeader.MenuDropdown.faqButton"],
                    icon:          icons["app.AppHeader.MenuDropdown.faqButton"],
                    iconAlignment: "left",
                    ontap:         "onHyperlinkTap"
                }, {
                    name:          "contactButton",
                    kind:          IconButton,
                    mixins:        [HyperLinkSupport],
                    classes:       "app-app-header-menu-dropdown__contact-button",
                    showing:       false,
                    theme:         buttons["app.AppHeader.MenuDropdown.contactButton"],
                    icon:          icons["app.AppHeader.MenuDropdown.contactButton"],
                    iconAlignment: "left",
                    ontap:         "onHyperlinkTap"
                }]
            }, {
                name:       "footer",
                classes:    "app-app-header-menu-dropdown__footer",
                components: [{
                    name:    "logoutButton",
                    kind:    LogoutButton,
                    classes: "app-app-header-menu-dropdown__logout-button",
                    showing: false,
                    theme:   buttons["app.AppHeader.MenuDropdown.logoutButton"],
                    ontap:   "onButtonTap"
                }]
            }]
        }]
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var $i18nService             = this.app.$.i18nService,
            state                    = this.state || {},
            language                 = $i18nService.get("language"),
            playlistsPageUrl         = get(config, "pageUrls.playlistsPageUrl", null),
            genresPageUrl            = get(config, "pageUrls.genresPageUrl", null),
            artistsPageUrl           = get(config, "pageUrls.artistsPageUrl", null),
            $homeButton              = this.$.homeButton,
            $searchButton            = this.$.searchButton,
            $playlistsButton         = this.$.playlistsButton,
            $genresButton            = this.$.genresButton,
            $artistsButton           = this.$.artistsButton,
            $privacyButton           = this.$.privacyButton,
            $cookiePreferencesButton = this.$.cookiePreferencesButton,
            $faqButton               = this.$.faqButton,
            $contactButton           = this.$.contactButton;

        $homeButton.set("tooltip", $i18nService.getString("app.AppHeader.HomeButton.tooltip"));
        $homeButton.set("caption", $i18nService.getString("app.AppHeader.HomeButton.caption"));
        $homeButton.set("href", quickMacroize("/{$language}/home", {
            language: language
        }));

        $searchButton.set("caption", $i18nService.getString("app.AppHeader.SearchButton.caption"));
        $searchButton.set("tooltip", $i18nService.getString("app.AppHeader.SearchButton.tooltip"));
        $searchButton.set("href", quickMacroize("/{$language}/search", {
            language: language
        }));

        // Playlists Button
        $playlistsButton.set("caption", $i18nService.getString("app.AppHeader.PlaylistsButton.caption"));
        $playlistsButton.set("tooltip", $i18nService.getString("app.AppHeader.PlaylistsButton.tooltip"));
        $playlistsButton.set("href", playlistsPageUrl ? quickMacroize(playlistsPageUrl, {
            language: $i18nService.get("language")
        }) : null);

        // Genres Button
        $genresButton.set("caption", $i18nService.getString("app.AppHeader.GenresButton.caption"));
        $genresButton.set("tooltip", $i18nService.getString("app.AppHeader.GenresButton.tooltip"));
        $genresButton.set("href", genresPageUrl ? quickMacroize(genresPageUrl, {
            language: $i18nService.get("language")
        }) : null);

        // Artists Button
        $artistsButton.set("tooltip", $i18nService.getString("app.AppHeader.ArtistsButton.tooltip"));
        $artistsButton.set("caption", $i18nService.getString("app.AppHeader.ArtistsButton.caption"));
        $artistsButton.set("href", artistsPageUrl ? quickMacroize(artistsPageUrl, {
            language: $i18nService.get("language")
        }) : null);

        this.$.categoryDropdown.set("state", state);
        this.$.brandDropdown.set("state", state);

        $privacyButton.set("caption", $i18nService.getString("app.AppHeader.PrivacyButton.caption"));
        $privacyButton.set("tooltip", $i18nService.getString("app.AppHeader.PrivacyButton.tooltip"));
        $privacyButton.set("href", get(config, "privacyUrl." + language, null));

        $cookiePreferencesButton.set("caption", $i18nService.getString("app.AppHeader.CookiePreferencesButton.caption"));
        $cookiePreferencesButton.set("tooltip", $i18nService.getString("app.AppHeader.CookiePreferencesButton.tooltip"));

        $faqButton.set("caption", $i18nService.getString("app.AppHeader.FaqButton.caption"));
        $faqButton.set("tooltip", $i18nService.getString("app.AppHeader.FaqButton.tooltip"));
        $faqButton.set("href", get(config, "faqUrl." + language, null));

        $contactButton.set("caption", $i18nService.getString("app.AppHeader.ContactButton.caption"));
        $contactButton.set("tooltip", $i18nService.getString("app.AppHeader.ContactButton.tooltip"));
        $contactButton.set("href", get(config, "contactUrl." + language, null));

        this.$.activator.set("tooltip", $i18nService.getString("app.AppHeader.MainMenu.Activator.tooltip"));
    },

    /**
     * Instruct the router to navigate to the new location
     *
     * @param   {enyo.Control}  sender  The sender
     * @return  {boolean}       Stop propagation
     * @private
     */
    onHyperlinkTap: function(sender) {
        var href = sender.getAttribute("href");

        // Empty url
        if (typeof href !== "string" || href === "") {
            return true;
        }

        this.hideDropdown(true);

        return onHyperlinkTap.call(this, sender);
    },

    /**
     * Hide this dropdown when one of it's buttons gets tapped.
     *
     * @param   {enyo.Control}  sender  The sender
     * @return  {boolean}       Stop propagation
     * @private
     */
    onButtonTap: function() {
        this.hideDropdown(true);

        return true;
    },

    /**
     * @private
     */
    dropdownRevealing: function() {
        var $activator = this.$.activator;

        !$activator.hasClass("active") && $activator.addClass("active");
    },

    /**
     * @private
     */
    dropdownHiding: function() {
        var $activator = this.$.activator;

        while ($activator.hasClass("active")) {
            $activator.removeClass("active");
        }
    }

});
